import { render, staticRenderFns } from "./confirm-spend.vue?vue&type=template&id=f439c458"
import script from "./confirm-spend.vue?vue&type=script&lang=js"
export * from "./confirm-spend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports